const initData = JSON.parse(localStorage.getItem('initData'))
export default initData

